const TOPICS = [
  { id: 1, label: '热辣滚烫票房', heat: '128万' },
  { id: 2, label: '繁花大结局', heat: '96万' },
  { id: 3, label: '国产喜剧推荐', heat: '85万' },
  { id: 4, label: '2024必看片单', heat: '78万' },
  { id: 5, label: '悬疑剧天花板', heat: '67万' },
  { id: 6, label: '古装仙侠排行', heat: '59万' },
  { id: 7, label: '高分韩剧合集', heat: '52万' },
  { id: 8, label: '科幻大片推荐', heat: '48万' },
  { id: 9, label: '周末观影指南', heat: '43万' },
  { id: 10, label: '动作片排行榜', heat: '38万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-600">影迷圈正在热议的内容标签</p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {TOPICS.map((topic) => (
              <div
                key={topic.id}
                className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-all cursor-pointer"
              >
                <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                  #{topic.label}
                </span>
                <span className="text-xs text-secondary-400 px-1.5 py-0.5 bg-secondary-100 rounded-full whitespace-nowrap">
                  {topic.heat}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}